export const _ADD               = "Rs6H5nzy63pq9QnU9KOZfg==";
export const _EDIT              = "JU4Pi+9O5OoQsx1NxKZxRQ==";
export const _VIEW              = "Nes2dxhFn13sb7Ek1E2yHQ==";
export const _DELETE            = "DYstmIq5bgFb8WHLLFf3+IsBxOI92ayFK0B79uJfhqQ=";
export const _RECOVER           = "WbhrGXlwulGxCfOs+NFPUtxCZLZjN/HnBCKy9Leb3iY=";
export const _LIST              = "gxlcAFQaWMxypnPnmAdHWQ==";
export const _TRASH             = "giiCBhyE5i+Mhr8wCKHoqg==";